export const SUPPORTED_LANGUAGES = ['en', 'el', 'de'];
export const DEFAULT_LANGUAGE = 'en';
//# sourceMappingURL=config.js.map